import React, {useState, useRef, useEffect, Fragment} from 'react';
import { v4 as uuidv4 } from 'uuid';
import {useRouter} from 'next/router';
import { useQuery, useQueries } from '@tanstack/react-query';
import ManageSchema from './management/ManageSchema';
import SchemaImport from '../sanity_ecommerce/schemas/register'
import {useStateContext} from '../context/StateContext';
import {SClient, urlFor} from '../lib/client';
import {Divider, VisDiv } from '.';
import ManagementSidebar from './gestioneDatabase/ManagementSidebar';
import { useCreateReplace } from '../hooks/mutations';
import { useQueryClient } from '@tanstack/react-query';
import { successAlert, errorAlert, addValueForDropdown, sortByLabel, labelAndName, sitesLabels } from '../lib/utils';
import {TextField, FieldDropdown} from '.';
import { referenceDoc } from './gestioneDatabase/Docs';
import { useAuthContext } from '../hooks/useAuthContext';
import TrueFalseToggle from './TrueFalseToggle';
import { _FETCH } from '../lib/patches';
import { registersQuery } from '../lib/data';
import TestButton from './frontend_components/TestButton';



/**
 * EditRegisters
 * 
 * This component is used to edit registers for a site
 * #registers
 * @param {Object} sites - All sites
 * @param {Object} registers - All registers for a site
 * @param {Function} updateRegister - Function to update a register
 * @param {String} queryName - Name of the query to invalidate
 * @param {Function} setEditRegister - Function to set the register to edit
 * @param {Array} selectedDevices - Selected devices to transfer
 * @param {Function} triggerSelectDevices - Function to trigger the selection of devices to transfer
 */
const EditRegisters = ({sites, registers, updateRegister=()=>{}, queryName,  setEditRegister, selectedDevices, triggerSelectDevices=()=>{}}) => {
    const {
        sUser,
        site,
        LDB,
        setLoading,
        setRegisters,
        register,
        currentTemplate,
        setCurrentTemplate,
        registerTemplates,
        setRegister,
        apiUrl
    } = useStateContext();
 
    const { user } = useAuthContext()
    const queryClient = useQueryClient()
      const fetchRoute = `${apiUrl}/calls/fetch-docs`

    const customerId = sUser?.customer._ref

    const [selectedDoc, setSelectedDoc] = useState(register)
    const [checkResetDays, setCheckResetDays] = useState(120)
    //const [selectedSite, setSelectedSite] = useState()


    
    const selectedDocFn = (data) => {
        //console.log("SELECTED DOC",data)
        if(data){
         setSelectedDoc(data)
         setCheckResetDays(data?.checkResetDays ? data?.checkResetDays : 120)
        }  
    }
    useEffect(() => {
        selectedDocFn(register)
        //console.log("SELECTED DOC USE EFFECT wdkòlwqdkowqkd",register, selectedDoc)
    },[register])

    const testFunction = () =>{
        console.log(selectedDoc)
    }
    const data = {
        schema: SchemaImport,
        documentName:"register",
        hide:["registerFields","label", "registerNonConformities", "devices", "postedBy", "status", "site", "template", "order", "_rev", "_updatedAt","_createdAt","_type"], 
        unique:[],
        required:["site", "template", "label"], 
        autoFields:[{schema:"site", referenceId: site?._id }, {schema:"template", referenceId: currentTemplate?._id }],
        existingDoc: register
    }


    const {mutate: updateEditRegister} = useCreateReplace({
        onMutate: async (newDoc) => {
    
            await queryClient.cancelQueries({ queryKey: queryName })
            const previousRegisters = queryClient.getQueryData(queryName)
            //console.log("PREVIOUS CLIENTS", previousClients)
            const doc = newDoc?.doc
            //console.log("MUTATION DOC", doc)
            queryClient.setQueryData(queryName, (old) =>{ 
                //console.log("DOC", doc)
                //console.log("OLD", old)
                const oldDoc = !Array.isArray(old) ? {} : old?.find?.(x=>x?._id==doc?._id) 
                //console.log("OLD_DOC", oldDoc)
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!==doc?._id), {...oldDoc, ...doc}]?.filter?.(x=>x?.site?._ref==site?._id)
                //console.log("NEW_DATA", newData)
                setRegisters(newData)
                if(doc?.site?._ref != site?._id)  setRegister(undefined)
                if(doc?.site?._ref == site?._id)  setRegister({...doc, checkResetDays: Number(doc?.checkResetDays)})
               
                return newData
            })
            return { previousSites: previousRegisters}
        },
        onError: (err, newDoc, context) => {
            errorAlert("UPDATE REGISTRO NON RIUSCITO, RIPROVA")
            queryClient.setQueryData(queryName, context?.previousRegisters)
            setRegisters(context.previousSites)
            //setClients(newData)
            console.error('Oh no, the update failed: ', err?.message)}
        })
//==================== TRANSFER SELECTED DEVICES TO ANOTHER REGISTER ==================================

    const [targetSiteForDeviceTransfer, setTargetSiteForDeviceTransfer] = useState(undefined)
    const [targetRegisterForDeviceTransfer, setTargetRegisterForDeviceTransfer] = useState(undefined)


    const {data: targetSiteForDeviceTransferRegistersData, isLoading: targetSiteForDeviceTransferRegistersLoading, refetch} =  useQuery(['targetSiteForDeviceTransferRegisters', targetSiteForDeviceTransfer], ()=>_FETCH({route: fetchRoute, user, query: registersQuery(targetSiteForDeviceTransfer?._id)}),{
            enabled: !! targetSiteForDeviceTransfer && !! sUser && !! user,
            onSuccess: (data)=>{
                    //testFloor({codeLocation:"inRegistersDataQuery", register, registers, registersData: data})
                  console.log("targetSiteForDeviceTransfer Registers Loaded", data)
            },
            onError:(error)=>{console.log("registersForDeviceTransfer not loaded", error)},
            //refetchOnWindowFocus: true, // Prevent refetch on window focus
            //refetchOnMount: true // Prevent refetch on component mount
        })

    const targetRegister = targetSiteForDeviceTransferRegistersData?.find((x)=> x._id == targetRegisterForDeviceTransfer?._id)
    const targetRegisterRegisterTemplate = registerTemplates?.find((x)=> x._id == targetRegister?.template?._ref) 
    const compatibleDevices = targetRegisterRegisterTemplate?.devices //_id
    const filterCompatibleDevices = selectedDevices?.filter((x)=>compatibleDevices?.some(z => z?._id == x?.templateDevice?._ref))?.map((item)=>{
        return ({
            ...item,
            register: referenceDoc(targetRegisterForDeviceTransfer?._id),
            site: referenceDoc(targetSiteForDeviceTransfer?._id)
        })
    })


        const {mutate: updateTargetRegister} = useCreateReplace({
            onSuccess: () => {
                console.log("updateTargetRegister succeded")
                successAlert("Registro Target aggiornato con successo")
                updateRegister({doc: {...register, devices: [...!Array.isArray(register?.devices) ? [] : register?.devices?.map(
                    (x)=>{
                        const isInTransferedDevices = filterCompatibleDevices?.some(z => z?._id == x?._id)
                        if(isInTransferedDevices) {
                            console.log("FOUND IN TRANSFERED DEVICES", x)
                            return undefined
                            }
                            return x
                        })
                        ?.filter((z)=>z)
                    ]}})   
                triggerSelectDevices(false)
            },
            onError:()=> {errorAlert("Errore: il registro target non é stato aggiornato")}
        })
 
        {/*                 transferDevice
                    targetSiteForDeviceTransfer, setTargetSiteForDeviceTransfer
                    targetRegisterForDeviceTransfer, setTargetRegisterForDeviceTransfer
                    targetSiteForDeviceTransferRegistersData, updateTargetRegister
*/}
    const transferDevices = () => {

        const updatedTargetRegister = {...targetRegister, devices: [...!Array.isArray(targetRegister?.devices) ? [] : targetRegister?.devices, ...!Array.isArray(filterCompatibleDevices) ? [] : filterCompatibleDevices]} //updatedTargetRegister
        console.log("transferDevice", {targetSiteForDeviceTransfer, targetRegister, targetRegisterRegisterTemplate, selectedDevices, filterCompatibleDevices})
        updateTargetRegister({doc: updatedTargetRegister})
    }
    const cancelTransferDevice = () => {
        setTargetRegisterForDeviceTransfer(undefined)
        setTargetSiteForDeviceTransfer(undefined)
        triggerSelectDevices(false)

    
    }
    //==========================================




    const save = () => {
        
        const queryDoc = {
            doc: {...selectedDoc, checkResetDays: Number(selectedDoc?.checkResetDays)},
        }
        console?.log("DOC TO SAVE", queryDoc)
       updateEditRegister(queryDoc); 
       setEditRegister(false)
       //setSelectedDoc(undefined)
      
   
    }
    const archive = () => {
        const queryDoc = {
            doc: {...selectedDoc, checkResetDays: Number(selectedDoc?.checkResetDays), status: "ARCHIVIATO"}}
        console.log(queryDoc)
        updateEditRegister(queryDoc); 
        setEditRegister(false)
        setCurrentTemplate(undefined);
        setRegister(undefined)
    }

        const restore = () => {
        const queryDoc = {
        doc: {...selectedDoc, checkResetDays: Number(selectedDoc?.checkResetDays), status: "ATTIVO"}}
        console.log(queryDoc)
        updateEditRegister(queryDoc); 
        setEditRegister(false)
        //setCurrentTemplate(undefined);
        //setRegister(undefined)
    }
    const consoleData = {
        selectedDoc,
        register,
        registerTemplates,
        targetSiteForDeviceTransfer,
    }
  
 if (!customerId){return <p>Customer not found</p>}
  return (

    <div className="products-heading">
            
            <div className="split-view">
                <VisDiv className="body">
                <TestButton consoleData={consoleData} message={"check edi register"} buttonId={"qoidjoiqwdjowiqjd"} />
                <VisDiv rules={[false]}>
                    <button onClick={testFunction}>test</button>
                </VisDiv>
               
                    <VisDiv>
                       
                        <TextField 
                            value={selectedDoc?.registerName ? selectedDoc?.registerName : ""} 
                            label={"NOME REGISTRO"}
                            onChange={(e) => setSelectedDoc({...selectedDoc, registerName: e.target.value})} 
                            //description={"Inserire un email per creare un nuovo utente o per duplicare uno esistente."} 
                            descriptionDivider={false}
                        />
                        <div style={{marginTop:"25px"}}>
                            <h4>TRASFERISCI REGISTRO AD UN ALTRO PLESSO DEL CLIENTE</h4>
                        </div>
                        <FieldDropdown
                            sorted={true}
                            descending={false}
                            isSearchable="isSearchable"
                            //initialValue={expandSupplier(supplierProduct?.supplier)}
                            placeHolder={"SELEZIONA PLESSO DA TRASFERIRE"}
                            options={!Array.isArray(sites) ? [] : sitesLabels(sites)}
                            onChange={(value) => { 
                                if(!value?._id) {
                                    //setSelectedSite(undefined)
                                    
                                    const newDoc = {...selectedDoc, site: referenceDoc(register?.site?._ref)}
                                    console.log("qlkdlqkwdmns !value?._id", {value,newDoc } )
                                    setSelectedDoc(newDoc)
                                } else {
                                    //setSelectedSite(value)
                                    setSelectedDoc({...selectedDoc, site: referenceDoc(value?._id)})  
                                }
                         
                            }}
                        />
                        <TextField 
                            value={checkResetDays} 
                            label={"GIORNI DI CHECK RESET"}
                            type='number'
                            onChange={(e) => setCheckResetDays(e.target.value)} 
                            onBlur={(e) => setSelectedDoc({...selectedDoc, checkResetDays: Number(checkResetDays)})}
                            //description={"Inserire un email per creare un nuovo utente o per duplicare uno esistente."} 
                            descriptionDivider={false}
                        />
                        <TrueFalseToggle 
                            value={selectedDoc?.notInMaintenance}
                            onClick={()=>setSelectedDoc({...selectedDoc, notInMaintenance: !selectedDoc?.notInMaintenance})}
                            label={"NON IN MANUTENZIONE"}
                        />

                            <VisDiv>
                                <VisDiv style={{display:"flex", marginTop:"20px", justifyContent:"left"}}>     
                                    <h4>SELEZIONA E TRASFERISCI PRESIDI IN UN ALTRO PLESSO DEL CLIENTE</h4>
                                </VisDiv>                  
                                <FieldDropdown
                                    isSearchable="isSearchable"
                                    initialValue={targetSiteForDeviceTransfer}
                                    placeHolder={"SELEZIONA PLESSO DI DESTINAZIONE PER TRASFERIMENTO PRESIDI"}
                                    options={!Array.isArray(sites) ? [] : sitesLabels(sites)?.sort(sortByLabel)}
                                    onChange={(value) => { 
                                        setTargetSiteForDeviceTransfer(value)
                                        setTargetRegisterForDeviceTransfer(undefined)
                                    }}
                                />
                                <VisDiv rules={[targetSiteForDeviceTransfer, targetSiteForDeviceTransferRegistersData?.length>0 ]}>
                                    <FieldDropdown
                                        isSearchable="isSearchable"
                                        initialValue={targetRegisterForDeviceTransfer}
                                        placeHolder={"SELEZIONA REGISTRO DI DESTINAZIONE"}
                                        options={!Array.isArray(targetSiteForDeviceTransferRegistersData) ? [] : targetSiteForDeviceTransferRegistersData?.filter(y=>y?.status !== "ARCHIVIATO")?.map((x)=>({...x, label:labelAndName(x?.label, x?.registerName) , value:x?.label}))}
                    
                                        onChange={(value) => { 
                                            setTargetRegisterForDeviceTransfer(value)
                                            triggerSelectDevices(true)
                                        }}
                                    />
                                </VisDiv>
                                <VisDiv rules={[selectedDevices?.length, targetRegisterForDeviceTransfer]} style={{display:"flex", justifyContent:"center"}}>
                                    <button type="button" style={{backgroundColor: "grey"}} className="btn" onClick={()=>cancelTransferDevice()}>{"ANNULLA"}</button>
                                </VisDiv>  
                                <VisDiv rules={[selectedDevices?.length, targetRegisterForDeviceTransfer]} style={{display:"flex", justifyContent:"center"}}>
                                    <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>transferDevices()}>{"TRASFERISCI PRESIDI"}</button>
                                </VisDiv>  
                                <Divider/> 
                            </VisDiv>
                        <VisDiv rules={[!targetRegisterForDeviceTransfer]} style={{display: "flex", alignItems:"center", justifyContent:"center", marginBottom:"15px"}} className='bottom-buttons'>
                            <button type="button" style={{backgroundColor: "green"}} className="btn" onClick={()=>save()} >
                                 {LDB("misc", "save")}
                            </button>
                            <VisDiv style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center"}} rules={[register?.status !== "ARCHIVIATO"]}>
                                <button type="button" style={{backgroundColor: "red"}} className="btn" onClick={()=>archive()} >
                                    {LDB("misc", "archive")}
                                </button>
                            </VisDiv>
                            <VisDiv style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center"}} rules={[register?.status == "ARCHIVIATO"]}>
                                <button type="button" style={{backgroundColor: "orange"}} className="btn" onClick={()=>restore()} >
                                    {"RIPRISTINA"}
                                </button>
                            </VisDiv>
                            <VisDiv style={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center"}} rules={[]}>
                                <button type="button" style={{backgroundColor: "grey"}} className="btn" onClick={()=>setEditRegister(false)} >
                                    {"ANNULLA"}
                                </button>
                            </VisDiv>
                        </VisDiv>
       {/*                  <ManageSchema
                            data = {data}
                            saveFn={save}
                            selectedDoc={selectedDocFn} 
                            archiveFn={archive}
                        />  */}            
                        </VisDiv>
                    </VisDiv>
                </div>
            </div>

  )
}

export default EditRegisters
